import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import default styles
import "material-icons/iconfont/material-icons.css"; // Import Material Icons

const DatePickerModel = (props) => {
  const datePickerRef = useRef(null); // Ref to access DatePicker input

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus(); // Programmatically trigger the focus event
    }
  };

  const years = Array.from(
    { length: new Date().getFullYear() - 1899 },
    (_, i) => i + 1900
  );
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <div className="d-flex align-items-center">
      <div className="position-relative w-100">
        <DatePicker
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="button"
                className="PrevButton_date"
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
              >
                <span className="material-icons">chevron_left</span>
              </button>
              <select
                className="react-datepicker_Select"
                value={date.getFullYear()}
                onChange={({ target: { value } }) => changeYear(value)}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>

              <select
                className="react-datepicker_Select"
                value={months[date.getMonth()]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
              >
                {months.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>

              <button
                type="button"
                className="PrevButton_date"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
              >
                <span className="material-icons">chevron_right</span>
              </button>
            </div>
          )}
          selected={props.startDate}
          onChange={props.handleDateChange}
          dateFormat="yyyy-MM-dd"
          placeholderText={props.placeholder || "Select Date"} // Dynamic placeholder
          className="form-control p-2 input-font-size border-head-color w-100"
          ref={datePickerRef} // Assign ref to the DatePicker
        />
        <span
          onClick={handleIconClick}
          className={`material-icons-outlined react-datepicker-wrapper_span pe-auto position-absolute datePickerStyle`}
          id="date-pick-icon"
        >
          calendar_month
        </span>
      </div>
    </div>
  );
};

export default DatePickerModel;
